import { Helmet } from "react-helmet-async";

const SITE_NAME = "Studio G4";
const DEFAULT_DESCRIPTION =
    "Award-winning architectural design + construction studio specialising in residential and commercial projects. From concept to completion.";
// Production origin — hardcoded so prerender/SSG (where `window` is undefined)
// still emits absolute og:url / og:image URLs. If the production domain ever
// changes, update this constant.
const SITE_ORIGIN = "https://studio-g4.co.uk";
const DEFAULT_IMAGE_ALT = "Studio G4 — architecture, project management and construction studio";
const DEFAULT_OG_IMAGE = "/Assets/SG4-OG-Image.jpg";

function toAbsolute(maybeRelative) {
    if (!maybeRelative) return undefined;
    if (/^https?:\/\//i.test(maybeRelative)) return maybeRelative;
    const prefix = maybeRelative.startsWith("/") ? "" : "/";
    return `${SITE_ORIGIN}${prefix}${maybeRelative}`;
}

export default function SEO({ title, description, path = "", image, imageAlt, type = "website" }) {
    const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Architecture, Project Management & Construction`;
    const desc = description || DEFAULT_DESCRIPTION;
    const url = (() => {
        if (!path || path === "/") return `${SITE_ORIGIN}/`;
        return `${SITE_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
    })();
    const absoluteImage = toAbsolute(image || DEFAULT_OG_IMAGE);
    const altText = imageAlt || DEFAULT_IMAGE_ALT;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:locale" content="en_GB" />
            {absoluteImage && <meta property="og:image" content={absoluteImage} />}
            {absoluteImage && <meta property="og:image:width" content="1193" />}
            {absoluteImage && <meta property="og:image:height" content="630" />}
            {absoluteImage && <meta property="og:image:alt" content={altText} />}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            {absoluteImage && <meta name="twitter:image" content={absoluteImage} />}
            {absoluteImage && <meta name="twitter:image:alt" content={altText} />}
        </Helmet>
    );
}
